import { gql } from '@urql/core';
import React, { useCallback } from 'react';
import {
    Content_File,
    Espin_Game_Definition_Enum,
    AllProfileViewsCardFragment,
    Espin_Profile_View_Type_Enum,
} from '../../../generated/spin-graphql';
import { ProfileViewsIcon } from '../../svg/dashboard/ProfileViewsIcon';
import { StatisticContainer } from '../StatisticContainer';
import { AllProfileViewsCard } from './AllProfileViewsCard';

type Props = {
    profileViews?: AllProfileViewsCardFragment[];
    totalViews: number;
    newViews: number;
    listOfFollows: string[];
    childrenSubscribed?: boolean;
    onUnfollow: (userId: string, viewType: Espin_Profile_View_Type_Enum) => void;
    onFollow: (userId: string, viewType: Espin_Profile_View_Type_Enum) => void;
};

export type SocialUserInfo = {
    slug: string;
    messageSlug: string;
    picture: Partial<Content_File>;
    label: string;
    subLabel?: string;
    graduating_class?: string;
    game?: {
        game_definition: Espin_Game_Definition_Enum;
        name: string;
    };
    following: boolean;
    deletedUser?: boolean;
    fakeUser?: boolean;
};

gql`
    fragment ProfileViews on espin_profile_view {
        ...AllProfileViewsCard
    }
`;

export const ProfileViews: React.FC<Props> = ({
    profileViews,
    totalViews,
    newViews,
    listOfFollows,
    childrenSubscribed,
    onFollow,
    onUnfollow,
}) => {
    const handleFollowButtonClicked = useCallback(
        (idToUse: string, following: boolean, viewType: Espin_Profile_View_Type_Enum) => {
            if (following) {
                onUnfollow(idToUse, viewType);
            } else {
                onFollow(idToUse, viewType);
            }
        },
        [onFollow, onUnfollow],
    );

    return (
        <div className="profile-views-container">
            <StatisticContainer
                label={'Total Profile Views'}
                icon={<ProfileViewsIcon />}
                value={totalViews.toLocaleString()}
            />
            <StatisticContainer
                label={'New Profile Views'}
                icon={<ProfileViewsIcon />}
                value={newViews.toLocaleString()}
            />
            <AllProfileViewsCard
                childrenSubscribed={childrenSubscribed}
                profileViews={profileViews}
                listOfFollows={listOfFollows}
                totalViews={totalViews}
                handleFollowButtonClicked={(
                    idToUse: string,
                    following: boolean,
                    viewType: Espin_Profile_View_Type_Enum,
                ) => handleFollowButtonClicked(idToUse, following, viewType)}
            />
        </div>
    );
};
